export default (theme) => ({
    root: {
        padding: 16,
        borderTop: `1px solid ${theme.colors.grey[100]}`,
    },
    link: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
    },
});
